
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/page-level-translations/[pageLang]/[[...path]]",
      function () {
        return require("private-next-pages/[site]/page-level-translations/[pageLang]/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[site]/page-level-translations/[pageLang]/[[...path]]"])
      });
    }
  